import axios from "axios";
import { API, getStaffToken } from "@/lib/api";

const authCfg = () => ({ headers: { Authorization: `Bearer ${getStaffToken()}` } });

const toUint8 = (b64) => {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export async function enableReminders() {
  if (!pushSupported()) throw new Error("This browser doesn't support push notifications — install Apex to your home screen first.");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Notifications were blocked — allow them in your browser settings.");
  const reg = await navigator.serviceWorker.ready;
  const { key } = (await axios.get(`${API}/push/public-key`)).data;
  const sub = (await reg.pushManager.getSubscription())
    || (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toUint8(key) }));
  await axios.post(`${API}/push/subscribe`, { subscription: sub.toJSON() }, authCfg());
  await axios.post(`${API}/push/test`, {}, authCfg());
}

export const getEod = () => axios.get(`${API}/staff/eod`, authCfg()).then((r) => r.data);

export async function downloadInvoicePdf(start, end) {
  const r = await axios.get(`${API}/invoices/pdf`, { ...authCfg(), params: { start, end }, responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const link = document.createElement("a");
  link.href = url;
  link.download = `ready-to-invoice_${start}_to_${end}.pdf`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}
